module.exports = __webpack_public_path__ + "img/refresh.49f7d295.svg";